export class ProductItem {
  id: number;
  productId: string;
  productName: string;
  productCategory: string;
  price: number;
}
